import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 代行入力依頼一覧参照API
// API仕様書_代行者
import {
  IAPI_AGE005_Request,
  IAPI_AGE005_Response,
} from "../../../type/apiType";

// 代行入力依頼取消API
// API仕様書_代行者
import {
  IAPI_AGE008_Request,
  IAPI_AGE008_Response,
} from "../../../type/apiType";

// 代行入力依頼一覧参照API
// API仕様書_代行者
const httpAPI_AGE005 = async (
  param: IAPI_AGE005_Request
): Promise<IAPI_AGE005_Response> => {
  let res = await http.post(ApiUrl.API_AGE005, {
    ...param,
  });

  return res.data;
};

// 代行入力依頼取消API
// API仕様書_代行者
const httpAPI_AGE008 = async (
  param: IAPI_AGE008_Request
): Promise<IAPI_AGE008_Response> => {
  let res = await http.post(ApiUrl.API_AGE008, {
    ...param,
  });

  return res.data;
};

export { httpAPI_AGE005, httpAPI_AGE008 };
